namespace Matrix.Data {
    export interface ExtensionFieldForm {
        DataType: ExtensionFieldDataTypeEditor;
        FieldName: ExtensionFieldNameEditor;
        FieldAlias: Serenity.StringEditor;
        Expression: Serenity.StringEditor;
        DisplayName: Serenity.StringEditor;
        VisibleInForm: Serenity.BooleanEditor;
        FormTab: Serenity.StringEditor;
        FormCategory: Serenity.StringEditor;
        FormWidth: FormWidthEditor;
        FormWidthUntilNext: Serenity.BooleanEditor;
        FormWidthJustThis: Serenity.BooleanEditor;
        IsRequired: Serenity.BooleanEditor;
        Cloneable: Serenity.BooleanEditor;
        DefaultValue: Serenity.StringEditor;
        MaxLength: Serenity.IntegerEditor;
        DecimalPlaces: Serenity.IntegerEditor;
        DateTimeKind: Serenity.EnumEditor;
        EditorType: Serenity.LookupEditor;
        VisibleInGrid: Serenity.BooleanEditor;
        Width: Serenity.IntegerEditor;
        Alignment: AlignmentStringEditor;
        QuickSearchType: Serenity.EnumEditor;
        DisplayFormat: Serenity.StringEditor;
        FormatterType: Serenity.LookupEditor;
        DisplayOrder: Serenity.IntegerEditor;
        LookupInclude: Serenity.BooleanEditor;
        ReadPermission: Serenity.StringEditor;
        ModifyPermission: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class ExtensionFieldForm extends Serenity.PrefixedContext {
        static formKey = 'Data.ExtensionField';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ExtensionFieldForm.init)  {
                ExtensionFieldForm.init = true;

                var s = Serenity;
                var w0 = ExtensionFieldDataTypeEditor;
                var w1 = ExtensionFieldNameEditor;
                var w2 = s.StringEditor;
                var w3 = s.BooleanEditor;
                var w4 = FormWidthEditor;
                var w5 = s.IntegerEditor;
                var w6 = s.EnumEditor;
                var w7 = s.LookupEditor;
                var w8 = AlignmentStringEditor;
                var w9 = StaticTextBlock;
                var w10 = ReadOnlyDateTime;

                Q.initFormType(ExtensionFieldForm, [
                    'DataType', w0,
                    'FieldName', w1,
                    'FieldAlias', w2,
                    'Expression', w2,
                    'DisplayName', w2,
                    'VisibleInForm', w3,
                    'FormTab', w2,
                    'FormCategory', w2,
                    'FormWidth', w4,
                    'FormWidthUntilNext', w3,
                    'FormWidthJustThis', w3,
                    'IsRequired', w3,
                    'Cloneable', w3,
                    'DefaultValue', w2,
                    'MaxLength', w5,
                    'DecimalPlaces', w5,
                    'DateTimeKind', w6,
                    'EditorType', w7,
                    'VisibleInGrid', w3,
                    'Width', w5,
                    'Alignment', w8,
                    'QuickSearchType', w6,
                    'DisplayFormat', w2,
                    'FormatterType', w7,
                    'DisplayOrder', w5,
                    'LookupInclude', w3,
                    'ReadPermission', w2,
                    'ModifyPermission', w2,
                    'CreatedBy', w9,
                    'CreatedWhen', w10,
                    'UpdatedBy', w9,
                    'UpdatedWhen', w10,
                    'Version', w9
                ]);
            }
        }
    }
}
